import React, { Component, createRef } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

//TODO: Deprecated
// Toolbar hidden for now; flip to true to restore the alignment / font-size shortcuts.
const SHOW_MULTI_SELECT_TOOLBAR = false;

export default class MultiSelectShortcuts extends Component {
  constructor(props) {
    super(props);
    this.state = { left: 0, top: 0 };
    this.innerRef = createRef();
  }

  componentDidMount() {
    this.reposition();
  }

  componentDidUpdate(prev) {
    if (prev.boxSelectedAll !== this.props.boxSelectedAll) this.reposition();
  }

  reposition() {
    const ids = this.props.boxSelectedAll;
    if (!Array.isArray(ids) || ids.length < 2) return;

    const canvasId = this.props.containedViewSelected === 0 ? "canvas" : "containedCanvas";
    const canvas = document.getElementById(canvasId);
    if (!canvas) return;
    const canvasRect = canvas.getBoundingClientRect();

    let minLeft = Infinity;
    let minTop = Infinity;

    ids.forEach((id) => {
      const el = document.getElementById("box-" + id);
      if (!el) return;
      const r = el.getBoundingClientRect();
      const relLeft = r.left - canvasRect.left;
      const relTop = r.top - canvasRect.top + canvas.scrollTop;
      if (relLeft < minLeft) minLeft = relLeft;
      if (relTop < minTop) minTop = relTop;
    });

    if (minLeft === Infinity) return;
    const menuWidth = this.innerRef.current ? this.innerRef.current.offsetWidth : 44;
    const left = Math.max(0, minLeft - menuWidth - 10);
    this.setState({ left, top: minTop });
  }

  render() {
    if (!SHOW_MULTI_SELECT_TOOLBAR) return null;
    const { boxSelectedAll, pluginToolbars, onAlign, onFontScale } = this.props;
    if (!Array.isArray(boxSelectedAll) || boxSelectedAll.length < 2) return null;

    const hasAtomic = boxSelectedAll.some(
      (id) => pluginToolbars[id] && pluginToolbars[id].pluginId === "AtomicBoxPlugin"
    );

    const alignButtons = [
      { type: "left", label: "\u22a3", tip: "Align left edges" },
      { type: "right", label: "\u22a2", tip: "Align right edges" },
      { type: "top", label: "\u22a4", tip: "Align top edges" },
      { type: "bottom", label: "\u22a5", tip: "Align bottom edges" },
      { type: "centerV", label: "\u2194", tip: "Center horizontally" },
      { type: "centerH", label: "\u2195", tip: "Center vertically" },
    ];

    return (
      <div style={{ position: "absolute", left: this.state.left, top: this.state.top, zIndex: 99 }}>
        <div ref={this.innerRef} id="multiSelectIcons">
          {alignButtons.map(({ type, label, tip }) => (
            <OverlayTrigger key={type} placement="right" overlay={<Tooltip>{tip}</Tooltip>}>
              <button
                className="editorTitleButton"
                style={{ fontSize: "16px", lineHeight: 1 }}
                onClick={(e) => {
                  e.stopPropagation();
                  onAlign(type);
                }}
              >
                {label}
              </button>
            </OverlayTrigger>
          ))}

          {hasAtomic && (
            <>
              <div
                style={{
                  width: "80%",
                  height: 1,
                  background: "rgba(148,163,184,0.3)",
                  margin: "4px 0",
                }}
              />
              <OverlayTrigger placement="right" overlay={<Tooltip>Increase text size</Tooltip>}>
                <button
                  className="editorTitleButton"
                  style={{ fontWeight: 700, fontSize: "15px", lineHeight: 1 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onFontScale(+0.15);
                  }}
                >
                  A
                </button>
              </OverlayTrigger>
              <OverlayTrigger placement="right" overlay={<Tooltip>Decrease text size</Tooltip>}>
                <button
                  className="editorTitleButton"
                  style={{ fontWeight: 400, fontSize: "10px", lineHeight: 1 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onFontScale(-0.15);
                  }}
                >
                  a
                </button>
              </OverlayTrigger>
            </>
          )}
        </div>
      </div>
    );
  }
}
